const linkWishList = document.querySelector("header .wishlist_link");
const iconWishList = document.querySelector("header .h-wishlist-icon");
const cartDrawer = document.querySelector("cart-drawer");
const cartDrawerWrapper = document.querySelector('.wrapper-cart-drawer')
const cartIconBubble = document.querySelector('#cart-icon-bubble')

function wishListUpdateCart() {
	const btnWishList = document.querySelectorAll(".wishlist-move-cart");
	btnWishList.forEach((btn) => {
		btn.addEventListener("click", (event) => {
			async function cartItems() {
				const response = await fetch("/cart.js");
                if (response.ok) {
                    setTimeout( async () => {
                        const cartIconBubblNext = await renderShopifySection("cart-icon-bubble");
                        const cartDrawerNext = await renderShopifySection("cart-drawer");
                        cartDrawerWrapper.innerHTML = stringToHTML(cartDrawerNext["cart-drawer"]).outerHTML;
                        cartIconBubble.innerHTML = stringToHTML(cartIconBubblNext["cart-icon-bubble"]).outerHTML;
                        console.log(cartDrawerWrapper);
                    }, 500);
                }
			}
			cartItems();
		});
	});
}

if (linkWishList && iconWishList) {
	linkWishList.addEventListener("click", (event) => {
		event.stopPropagation();
		iconWishList.click();
	});

	iconWishList.addEventListener("click", (event) => {
		event.stopPropagation();
		setTimeout(() => {
			wishListUpdateCart();
		}, 1000);
	});
}


// Section rendering add-on
async function renderShopifySection(sections) {
    try {
      const response = await fetch(`?sections=${sections}`);
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const html = await response.json();
      return html;
    } catch (error) {
      console.error(`Error: ${error.message}`);
    }
  }
  
  const support = () => {
    if (!window.DOMParser) return false;
    const parser = new DOMParser();
    try {
      parser.parseFromString("x", "text/html");
    } catch (err) {
      return false;
    }
    return true;
  };
  
  const stringToHTML = (str) => {
    // If DOMParser is supported, use it
    if (support()) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(str, "text/html");
      return doc.body;
    }
    // Otherwise, fallback to old-school method
    const dom = document.createElement("div");
    dom.innerHTML = str;
    return dom;
  };
  
  